<template>
    <Transition name="fade">
        <div
            id="viewpointDetail"
            class="w-64 sm:w-96 bg-white/70 backdrop-blur-sm duration-200 ease-out rounded-lg shadow overflow-hidden z-20 text-sm"
            v-show="store.activeViewpoint"
        >
            <div
                class="relative h-10 flex items-center justify-between p-2 border-b border-gray-200/50 w-full"
            >
                <Transition name="fade">
                    <h3
                        class="absolute text-sm font-semibold text-gray-800"
                        :key="store.activeViewpoint?.title"
                    >
                        {{ store.activeViewpoint?.title }}
                    </h3>
                </Transition>
                <button
                    class="absolute right-2 flex items-center justify-center w-6 h-6 rounded-md hover:bg-gray-100/70 transition-colors"
                    @click="store.activeViewpoint = null"
                >
                    <span
                        class="esri-icon esri-icon-left-triangle-arrow transition-transform duration-200 text-lg!"
                    ></span>
                </button>
            </div>
            <div
                class="relative p-3 h-40 duration-300 overflow-auto sm:overflow-hidden"
            >
                <Transition
                    name="fade"
                    @after-enter="resizeText"
                >
                    <p
                        :id="`viewpointDetailText-${store.activeViewpoint?.id}`"
                        :key="store.activeViewpoint?.text"
                        class="absolute w-[calc(100%-1.5rem)]"
                    >
                        {{ store.activeViewpoint?.text }}
                    </p>
                </Transition>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { watch } from "vue"
import { useStore } from "../store"

const store = useStore()

/* watch(
    () => store.activeViewpoint,
    newVal => {
        if (newVal) {
            setTimeout(() => {
                const textElement = document.getElementById(
                    `viewpointDetailText-${newVal.id}`,
                )
                if (textElement) {
                    const scrollHeight = textElement.scrollHeight
                    const parentElement = textElement.parentElement
                    if (parentElement) {
                        parentElement.style.height = `calc(${scrollHeight}px + 1.5rem)` // 1rem for padding
                    }
                }
            }, 300)
        }
    },
) */

const resizeText = () => {
    const vp = store.activeViewpoint
    if (!vp) return

    const textElement = document.getElementById(`viewpointDetailText-${vp.id}`)
    if (!textElement) return

    const parent = textElement.parentElement
    if (!parent) return

    const scrollHeight = textElement.scrollHeight
    parent.style.height = `calc(${scrollHeight}px + 1.5rem)`
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
